var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInTransitBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white",
    stroke: "#6FB24B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 9.57141H15.75C15.905 9.57141 16.055 9.64641 16.15 9.77141L17.3 11.3064C17.43 11.4814 17.5 11.6914 17.5 11.9064V13.5714C17.5 13.8464 17.275 14.0714 17 14.0714H16.5C16.5 14.9014 15.83 15.5714 15 15.5714C14.17 15.5714 13.5 14.9014 13.5 14.0714H10.5C10.5 14.9014 9.83 15.5714 9 15.5714C8.17 15.5714 7.5 14.9014 7.5 14.0714C6.95 14.0714 6.5 13.6214 6.5 13.0714V8.57141C6.5 8.02141 6.95 7.57141 7.5 7.57141H13.5C14.05 7.57141 14.5 8.02141 14.5 8.57141V9.57141ZM8.5 14.0714C8.5 14.3464 8.725 14.5714 9 14.5714C9.275 14.5714 9.5 14.3464 9.5 14.0714C9.5 13.7964 9.275 13.5714 9 13.5714C8.725 13.5714 8.5 13.7964 8.5 14.0714ZM15.75 10.3214L16.73 11.5714H14.5V10.3214H15.75ZM14.5 14.0714C14.5 14.3464 14.725 14.5714 15 14.5714C15.275 14.5714 15.5 14.3464 15.5 14.0714C15.5 13.7964 15.275 13.5714 15 13.5714C14.725 13.5714 14.5 13.7964 14.5 14.0714Z",
    fill: "#6FB24B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransitBlank);
export default __webpack_public_path__ + "static/media/in_transit-blank.4f577230.svg";
export { ForwardRef as ReactComponent };